import { useState } from 'react';

import OPE from 'js/on-page-editing';

import ContentWithSidebar from 'components/content-with-sidebar/ContentWithSidebar';
import Rss from 'components/rss/Rss';
import Message from 'components/message/Message';
import ContentContainer from 'components/content-container/ContentContainer';
import Icon, { type IconName } from 'components/icon/Icon';

import { IStatusPage } from 'source/NFR.types';

const StatusPage: React.FC<IStatusPage> = ({ title, serviceStatus, statusMessage, rss, onPageEditing, icons }) => {
  const [isCollapsed, setIsCollapsed] = useState<Record<string, boolean>>({
    site: false,
    skattefunn: false,
    projectBank: false
  });

  const toggleCollapse = (section: string) => {
    setIsCollapsed(prevState => ({
      ...prevState,
      [section]: !prevState[section]
    }));
  };

  return (
    <ContentContainer className="status-page" onPageEditing={onPageEditing}>
      <h1>{title}</h1>

      <div className="status-page__mode">
        {icons?.map((icon, index) => (
          <div key={index} className="status-page__status">
            {icon.title}
            <Icon name={icon.name as IconName} className={`icon--${icon.name}`} />
          </div>
        ))}
      </div>

      <div className="status-page__message">{statusMessage && <Message {...statusMessage} />}</div>

      <ContentWithSidebar className="status-page__content">
        <div>
          {serviceStatus?.map((status, index) => (
            <div key={index} className="status-page__collapse">
              <div className="status-page__text">
                <h2 onClick={() => toggleCollapse(status.title)}>
                  <Icon name="arrow-down" className={isCollapsed[status.title] ? 'rotate-180' : ''} />
                  {status.title}
                </h2>
                <Icon name={status.icon as IconName} className={`icon--${status.icon}`} />
              </div>
              {isCollapsed[status.title] && (
                <div className="status-page__info">
                  <p {...OPE(onPageEditing?.title)}>{status.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {rss && <Rss {...rss} />}
      </ContentWithSidebar>
    </ContentContainer>
  );
};

StatusPage.displayName = 'StatusPage';

export default StatusPage;
